import { fetchPaymentsAction } from 'redux/actions/paymentsActions';
import { generateRequestWithDataReducer } from 'redux/utils/requestWithData';

export const paymentsReducer = generateRequestWithDataReducer(fetchPaymentsAction, true);
